const y = (r, e, t) => t ? r === "primary-brand" || r === "primary-gray" ? "white" : "disabled" : r === "secondary-gray" || r === "text-gray" || r === "ghost" ? "default-gray" : r === "primary-ghost" ? e ? "white" : "primary-brand" : r === "text" || r === "primary-ghost" || r === "secondary-blue" ? "primary-brand" : "white", o = (r, e) => e ? r === "primary-brand" || r === "primary-gray" ? "white" : "disabled" : r === "secondary-gray" || r === "ghost" ? "default-gray" : r === "secondary-blue" ? "primary-brand" : "white";
export {
  o as selectIconButtonColor,
  y as selectIconColor
};
//# sourceMappingURL=index.es672.js.map
